import { Component, OnInit} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PageService } from 'src/app/_services/page.service';
import { Title } from '@angular/platform-browser';
import { Page } from 'src/app/_models/page';

@Component({
    selector: 'app-add-page',
    templateUrl: './add-page.component.html',
    styleUrls: ['./add-page.component.css'],
    standalone: false
})
export class AddPageComponent implements OnInit {
  form: UntypedFormGroup;
  loading = true;
  submitting = false;
  id: string;
  page: Page = null;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private pageService: PageService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute
  ) {
    this.buildForm();
    this.id = this.activatedRoute.snapshot.paramMap.get('id') ?? '';
    if (this.id) {
      this.titleService.setTitle('Edit Page - Pages');
    }
  }

  ngOnInit() {
    if (this.id) {
      this.pageService.loadPageById(this.id).subscribe(
          (page: Page) => {
            this.page = page;
            this.form.get('title').setValue(this.page.title);
            this.form.get('titleFr').setValue(this.page.titleFr);
            this.form.get('content').setValue(this.page.content);
            this.form.get('contentFr').setValue(this.page.contentFr);
            this.loading = false;
          },
          () => this.router.navigateByUrl('/admin/pages'),
          null
      );
    } else {
      this.titleService.setTitle('New Page - Pages');
      this.buildForm();
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      title: new UntypedFormControl('', [Validators.required]),
      titleFr: new UntypedFormControl('', [Validators.required]),
      content: new UntypedFormControl('', [Validators.required]),
      contentFr: new UntypedFormControl('', [Validators.required])
    });
  }

  save() {
    this.pageService.savePage(this.form.value, this.id).subscribe(
      () => {},
      () => (this.submitting = false),
      () => this.router.navigateByUrl('/admin/pages')
    );
  }
}